import React from "react";
import ReadAloud from "../../components/ReadAloud/ReadAloud";

const Parts = ({ fontSize }) => {
  return (
    <div className="page">
  
        <h1 className="page-title">Parts</h1>
        <ReadAloud>
        <div
          className="page-text"
          style={{
            fontSize: `${18 + fontSize}px`,
            marginBottom: "2vh",
          }}
        >
          This year we added 11 new parts to the Registry, summarized as
          follows.
        </div>
        <div
          className="page-text"
          style={{
            fontSize: `${18 + fontSize}px`,
            marginBottom: "2vh",
          }}
        >
          <table style={{width: "100%"}}>
          <thead>
          <tr>
          <th style={{fontSize: `${24 + fontSize}px`}}>Part Name</th>
          <th style={{fontSize: `${24 + fontSize}px`}}>Part Type</th>
          <th style={{fontSize: `${24 + fontSize}px`}}>Description</th>
          </tr>
          </thead>
          <tbody>
          <tr>
          <td>BBa_K4393000</td>
          <td>Coding</td>
          <td>NPP synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393001</td>
          <td>Coding</td>
          <td>Alpha pinene synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393002</td>
          <td>Coding</td>
          <td>Beta caryophyllene synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393003</td>
          <td>Coding</td>
          <td>Olivetolic acid synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393004</td>
          <td>Coding</td>
          <td>Prenyltransferase 4</td>
          </tr>
          <tr>
          <td>BBa_K4393005</td>
          <td>Coding</td>
          <td>Acyl activating enzyme 1</td>
          </tr>
          <tr>
          <td>BBa_K4393006</td>
          <td>Coding</td>
          <td>3,5,7-trioxododecanoyl-CoA synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393007</td>
          <td>Coding</td>
          <td>Cannabidiolic acid synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393008</td>
          <td>Coding</td>
          <td>Tetrahydrocannabinolic acid synthase</td>
          </tr>
          <tr>
          <td>BBa_K4393009</td>
          <td>Regulatory</td>
          <td>Yeast Inducible Promoter pGAL7</td>
          </tr>
          <tr>
          <td>BBa_K4393010</td>
          <td>Terminator</td>
          <td>Yeast Transcription Terminator tTPS1</td>
          </tr>
          </tbody>
          </table>
        </div>
      </ReadAloud>
    </div>
  );
};

export default Parts;
